import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/kiosk/patient-kiosk')({ staticData: { team: 'forms' } });
